<template>
  <div class="min-h-screen">
    <div
      v-if="loader"
      class="fixed inset-0 flex items-center justify-center bg-white z-50"
    >
      <img
        src="@/assets/imgs/tuin_loader_v2.gif"
        alt="cargando..."
        class="w-[500px]"
      >
    </div>
    <!-- ToastAlert Component -->
    <div class="flex">
      <ToastAlert :is-active="toastAlert" :type="typeMsg" :message="msg"/>
    </div>

    <!-- Header Section -->
    <div class="max-w-6xl mx-auto mt-5">
      <!-- Desktop Header -->
      <div class="hidden sm:flex justify-between items-center mb-8 sm:mb-40">
        <div>
          <h1 class="text-3xl font-medium text-gray-900 mb-2">
            ¡Te damos la bienvenida, {{ userName }}!
          </h1>
          <p class="text-gray-900 text-base">
            Comparte tu perfil de Tuin en tus redes sociales
          </p>
        </div>
        <div class="flex space-x-4">
          <div class="relative">
            <button 
              class="px-5 py-2.5 bg-tuin-100 text-white rounded-lg hover:bg-tuin_hover transition-colors flex items-center space-x-2"
              @click="toggleShareMenu"
            >
              <span class="text-base font-medium">Compartir</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6,9 12,15 18,9"></polyline>
              </svg>
            </button>
            <!-- Dropdown menu -->
            <div v-if="showShareMenu" class="absolute right-0 mt-2 w-40 bg-white rounded-md shadow-lg z-10">
              <div class="py-1">
                <button 
                  @click="openProfileModal(); callActionLog(session?.id, 54, 'Usuario hizó clic en el botón de compartir perfil del usuario desde el Home de Asesores')"
                  class="flex items-center gap-2 w-full text-left px-4 py-2 text-sm text-custom_gray hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16 9C16 10.0609 15.5786 11.0783 14.8284 11.8284C14.0783 12.5786 13.0609 13 12 13C10.9391 13 9.92172 12.5786 9.17157 11.8284C8.42143 11.0783 8 10.0609 8 9C8 7.93913 8.42143 6.92172 9.17157 6.17157C9.92172 5.42143 10.9391 5 12 5C13.0609 5 14.0783 5.42143 14.8284 6.17157C15.5786 6.92172 16 7.93913 16 9ZM14 9C14 9.53043 13.7893 10.0391 13.4142 10.4142C13.0391 10.7893 12.5304 11 12 11C11.4696 11 10.9609 10.7893 10.5858 10.4142C10.2107 10.0391 10 9.53043 10 9C10 8.46957 10.2107 7.96086 10.5858 7.58579C10.9609 7.21071 11.4696 7 12 7C12.5304 7 13.0391 7.21071 13.4142 7.58579C13.7893 7.96086 14 8.46957 14 9Z" fill="#737373"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12C1 18.075 5.925 23 12 23C18.075 23 23 18.075 23 12C23 5.925 18.075 1 12 1ZM3 12C3 14.09 3.713 16.014 4.908 17.542C5.74744 16.4401 6.83015 15.5471 8.07164 14.9327C9.31312 14.3183 10.6798 13.9991 12.065 14C13.4324 13.9984 14.7821 14.3091 16.0111 14.9084C17.2402 15.5077 18.3162 16.3797 19.157 17.458C20.0234 16.3216 20.6068 14.9952 20.8589 13.5886C21.111 12.182 21.0244 10.7355 20.6065 9.36898C20.1886 8.00243 19.4512 6.75505 18.4555 5.73004C17.4598 4.70503 16.2343 3.93186 14.8804 3.47451C13.5265 3.01716 12.0832 2.88877 10.6699 3.09997C9.25652 3.31117 7.91379 3.85589 6.75277 4.68905C5.59175 5.52222 4.64581 6.61987 3.99323 7.8912C3.34065 9.16252 3.00018 10.571 3 12ZM12 21C9.93391 21.0033 7.93014 20.2926 6.328 18.988C6.97281 18.0646 7.83119 17.3107 8.83008 16.7905C9.82896 16.2702 10.9388 15.999 12.065 16C13.1772 15.999 14.2735 16.2635 15.263 16.7713C16.2524 17.2792 17.1064 18.0158 17.754 18.92C16.1395 20.267 14.1026 21.0033 12 21Z" fill="#737373"/>
                  </svg>
                  Perfil
                </button>
                <button 
                  @click="openCompanyModal(); callActionLog(session?.id, 55, 'Usuario hizó clic en el botón de compartir perfil de la inmobiliaria desde el Home de Asesores')"
                  class="flex items-center gap-2 w-full text-left px-4 py-2 text-sm text-custom_gray hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M20 6C20.58 6 21.05 6.2 21.42 6.59C21.8 7 22 7.45 22 8V19C22 19.55 21.8 20 21.42 20.41C21.05 20.8 20.58 21 20 21H4C3.42 21 2.95 20.8 2.58 20.41C2.2 20 2 19.55 2 19V8C2 7.45 2.2 7 2.58 6.59C2.95 6.2 3.42 6 4 6H8V4C8 3.42 8.2 2.95 8.58 2.58C8.95 2.2 9.42 2 10 2H14C14.58 2 15.05 2.2 15.42 2.58C15.8 2.95 16 3.42 16 4V6H20ZM4 8V19H20V8H4ZM14 6V4H10V6H14Z" fill="#737373"/>
                  </svg>
                  Inmobiliaria
                </button>
              </div>
            </div>
          </div>
          <fwb-tooltip v-if="isLimitReached" placement="bottom">
            <template #trigger>
              <button
                @click="handleAddProperty"
                :disabled="isLimitReached"
                :class="[
                  'w-full max-w-xs px-5 py-2.5 rounded-lg transition-colors',
                  isLimitReached 
                    ? 'border border-gray-400 text-gray-400 cursor-not-allowed opacity-60' 
                    : 'border border-tuin-100 text-tuin-100 hover:text-white hover:border-tuin_hover hover:bg-tuin_hover'
                ]"
              >
                Agregar Propiedad
              </button>
            </template>
            <template #content>
              Has alcanzado el límite de {{ propertyLimit }} propiedades
            </template>
          </fwb-tooltip>

          <button
            v-else
            @click="handleAddProperty"
            class="w-full max-w-xs px-5 py-2.5 border border-tuin-100 text-tuin-100 rounded-lg hover:text-white hover:border-tuin_hover hover:bg-tuin_hover transition-colors"
          >
            Agregar Propiedad
          </button>
        </div>
      </div>

      <!-- Mobile Header -->
      <div class="sm:hidden text-center mb-8">
        <h1 class="text-3xl font-medium text-gray-900 mb-4">
          ¡Te damos la bienvenida, {{ userName }}!
        </h1>
        <p class="text-gray-900 text-base mb-6">
          Comparte tu perfil de Tuin en tus redes sociales
        </p>
        
        <!-- Mobile Buttons -->
        <div class="flex flex-col items-center space-y-3 px-20">
          <div class="relative w-full max-w-xs">
            <button 
              class="w-full px-5 py-2.5 bg-tuin-100 text-white rounded-lg hover:bg-tuin_hover transition-colors flex items-center justify-center space-x-2"
              @click="toggleShareMenu"
            >
              <span>Compartir</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6,9 12,15 18,9"></polyline>
              </svg>
            </button>
            <!-- Mobile Dropdown menu -->
            <div v-if="showShareMenu" class="absolute left-0 right-0 mt-2 bg-white rounded-md shadow-lg z-10">
              <div class="py-1">
                <button 
                  @click="openProfileModal(); callActionLog(session?.id, 54, 'Usuario hizó clic en el botón de compartir perfil del usuario desde el Home de Asesores')"
                  class="flex items-center gap-2 w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16 9C16 10.0609 15.5786 11.0783 14.8284 11.8284C14.0783 12.5786 13.0609 13 12 13C10.9391 13 9.92172 12.5786 9.17157 11.8284C8.42143 11.0783 8 10.0609 8 9C8 7.93913 8.42143 6.92172 9.17157 6.17157C9.92172 5.42143 10.9391 5 12 5C13.0609 5 14.0783 5.42143 14.8284 6.17157C15.5786 6.92172 16 7.93913 16 9ZM14 9C14 9.53043 13.7893 10.0391 13.4142 10.4142C13.0391 10.7893 12.5304 11 12 11C11.4696 11 10.9609 10.7893 10.5858 10.4142C10.2107 10.0391 10 9.53043 10 9C10 8.46957 10.2107 7.96086 10.5858 7.58579C10.9609 7.21071 11.4696 7 12 7C12.5304 7 13.0391 7.21071 13.4142 7.58579C13.7893 7.96086 14 8.46957 14 9Z" fill="#737373"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12C1 18.075 5.925 23 12 23C18.075 23 23 18.075 23 12C23 5.925 18.075 1 12 1ZM3 12C3 14.09 3.713 16.014 4.908 17.542C5.74744 16.4401 6.83015 15.5471 8.07164 14.9327C9.31312 14.3183 10.6798 13.9991 12.065 14C13.4324 13.9984 14.7821 14.3091 16.0111 14.9084C17.2402 15.5077 18.3162 16.3797 19.157 17.458C20.0234 16.3216 20.6068 14.9952 20.8589 13.5886C21.111 12.182 21.0244 10.7355 20.6065 9.36898C20.1886 8.00243 19.4512 6.75505 18.4555 5.73004C17.4598 4.70503 16.2343 3.93186 14.8804 3.47451C13.5265 3.01716 12.0832 2.88877 10.6699 3.09997C9.25652 3.31117 7.91379 3.85589 6.75277 4.68905C5.59175 5.52222 4.64581 6.61987 3.99323 7.8912C3.34065 9.16252 3.00018 10.571 3 12ZM12 21C9.93391 21.0033 7.93014 20.2926 6.328 18.988C6.97281 18.0646 7.83119 17.3107 8.83008 16.7905C9.82896 16.2702 10.9388 15.999 12.065 16C13.1772 15.999 14.2735 16.2635 15.263 16.7713C16.2524 17.2792 17.1064 18.0158 17.754 18.92C16.1395 20.267 14.1026 21.0033 12 21Z" fill="#737373"/>
                  </svg>
                  Perfil
                </button>
                <button 
                  @click="openCompanyModal(); callActionLog(session?.id, 55, 'Usuario hizó clic en el botón de compartir perfil de la inmobiliaria desde el Home de Asesores')"
                  class="flex items-center gap-2 w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M20 6C20.58 6 21.05 6.2 21.42 6.59C21.8 7 22 7.45 22 8V19C22 19.55 21.8 20 21.42 20.41C21.05 20.8 20.58 21 20 21H4C3.42 21 2.95 20.8 2.58 20.41C2.2 20 2 19.55 2 19V8C2 7.45 2.2 7 2.58 6.59C2.95 6.2 3.42 6 4 6H8V4C8 3.42 8.2 2.95 8.58 2.58C8.95 2.2 9.42 2 10 2H14C14.58 2 15.05 2.2 15.42 2.58C15.8 2.95 16 3.42 16 4V6H20ZM4 8V19H20V8H4ZM14 6V4H10V6H14Z" fill="#737373"/>
                  </svg>
                  Inmobiliaria
                </button>
              </div>
            </div>
          </div>
          <button 
            class="w-full max-w-xs px-5 py-2.5 border border-tuin-100 text-tuin-100 rounded-lg hover:text-white hover:border-tuin_hover hover:bg-tuin_hover transition-colors"
            @click="addProperty"
          >
            Agregar Propiedad
          </button>
        </div>
      </div>

      <!-- Menu Grid Mobile-->
      <div class="sm:hidden">
        <div class="grid grid-cols-2 gap-4 max-w-xl mx-auto">
          <!-- Bolsa Inmobiliaria -->
          <div 
            class="menu-item"
            @click="navigateTo('bolsa-inmobiliaria')"
          >
            <div class="menu-icon bg-black text-white hover:bg-tuin_hover transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" width="95" height="66" viewBox="0 0 95 66" fill="none">
                <path d="M94.37 22.5458L84.8997 3.59775C84.5508 2.90034 84.068 2.27849 83.4787 1.7677C82.8895 1.25691 82.2054 0.867193 81.4656 0.620803C80.7257 0.374414 79.9446 0.276179 79.1667 0.331708C78.3889 0.387236 77.6296 0.595442 76.9323 0.944433L67.7032 5.55713L48.2616 0.413769C47.7627 0.283952 47.239 0.283952 46.7401 0.413769L27.2985 5.55713L18.0694 0.944433C17.372 0.595442 16.6128 0.387236 15.835 0.331708C15.0571 0.276179 14.276 0.374414 13.5361 0.620803C12.7963 0.867193 12.1122 1.25691 11.523 1.7677C10.9337 2.27849 10.4509 2.90034 10.102 3.59775L0.631704 22.5421C0.282713 23.2394 0.0745079 23.9987 0.0189792 24.7765C-0.0365495 25.5544 0.0616858 26.3355 0.308075 27.0754C0.554464 27.8152 0.944181 28.4993 1.45497 29.0885C1.96576 29.6778 2.58761 30.1606 3.28502 30.5095L13.3046 35.5229L33.8965 50.2294C34.2001 50.445 34.5412 50.6023 34.9022 50.6933L58.6522 56.6308C59.1496 56.7555 59.6708 56.7493 60.165 56.6127C60.6593 56.4761 61.1097 56.2139 61.4725 55.8515L81.9087 35.4116L91.713 30.5095C93.1205 29.8049 94.1906 28.5702 94.6882 27.0769C95.1857 25.5836 95.0699 23.9538 94.3663 22.5458H94.37ZM74.0006 34.9292L61.2313 24.7019C60.6593 24.2437 59.938 24.0134 59.2063 24.0552C58.4746 24.097 57.7842 24.4079 57.268 24.9282C50.6589 31.5856 43.2926 30.7433 38.5946 27.7745L54.6407 12.1886H66.4452L76.5426 32.3798L74.0006 34.9292ZM15.4124 6.25107L23.0087 10.0437L13.5198 28.988L5.93834 25.1991L15.4124 6.25107ZM58.4592 50.4595L36.895 45.0712L18.6372 32.031L29.0278 11.2497L47.5008 6.35498L51.1376 7.31611L34.4383 23.5255L34.4087 23.5589C33.78 24.1875 33.3006 24.9492 33.0057 25.7879C32.7109 26.6266 32.6081 27.5207 32.705 28.4044C32.8018 29.2881 33.0959 30.1388 33.5655 30.8936C34.0351 31.6485 34.6682 32.2882 35.418 32.7657C43.0477 37.6382 52.2546 36.8478 59.5057 30.9103L69.7665 39.1522L58.4592 50.4595ZM81.4671 28.9843L71.9967 10.0585L79.5893 6.25107L89.0633 25.1991L81.4671 28.9843ZM48.9036 63.3735C48.7432 64.0152 48.3731 64.5849 47.8521 64.9923C47.3311 65.3997 46.689 65.6214 46.0276 65.6224C45.7836 65.6225 45.5406 65.5926 45.304 65.5333L29.8405 61.6665C29.4788 61.5772 29.1375 61.4198 28.8348 61.2026L19.0565 54.2187C18.4553 53.7466 18.0593 53.0608 17.951 52.3041C17.8428 51.5474 18.0306 50.778 18.4753 50.1563C18.9201 49.5346 19.5875 49.1084 20.3387 48.9665C21.0898 48.8246 21.8667 48.9779 22.5077 49.3944L31.8258 56.0519L46.7587 59.7776C47.5223 59.9687 48.1789 60.4552 48.5839 61.1302C48.9889 61.8053 49.1092 62.6135 48.9184 63.3772L48.9036 63.3735Z" fill="white"/>
              </svg>
            </div>
            <span class="menu-label">Bolsa Inmobiliaria</span>
          </div>

          <!-- Mis propiedades -->
          <div 
            class="menu-item"
            @click="navigateTo('mis-propiedades')"
          >
            <div class="menu-icon bg-black text-white hover:bg-tuin_hover transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" width="66" height="58" viewBox="0 0 66 58" fill="none">
                <path d="M63.625 53.3739H59.25V22.7489C59.25 21.5886 58.7891 20.4758 57.9686 19.6553C57.1481 18.8349 56.0353 18.3739 54.875 18.3739H37.375V5.24894C37.3755 4.45669 37.1609 3.67917 36.754 2.99937C36.3472 2.31957 35.7634 1.763 35.0649 1.38907C34.3665 1.01514 33.5796 0.837882 32.7883 0.87622C31.997 0.914559 31.2309 1.16705 30.5719 1.60675L8.69687 16.1864C8.09679 16.5868 7.60501 17.1294 7.26534 17.7658C6.92566 18.4022 6.74863 19.1127 6.75 19.8341V53.3739H2.375C1.79484 53.3739 1.23844 53.6044 0.828204 54.0146C0.417968 54.4249 0.1875 54.9813 0.1875 55.5614C0.1875 56.1416 0.417968 56.698 0.828204 57.1082C1.23844 57.5185 1.79484 57.7489 2.375 57.7489H63.625C64.2052 57.7489 64.7616 57.5185 65.1718 57.1082C65.582 56.698 65.8125 56.1416 65.8125 55.5614C65.8125 54.9813 65.582 54.4249 65.1718 54.0146C64.7616 53.6044 64.2052 53.3739 63.625 53.3739ZM54.875 22.7489V53.3739H37.375V22.7489H54.875ZM11.125 19.8341L33 5.24894V53.3739H11.125V19.8341ZM28.625 27.1239V31.4989C28.625 32.0791 28.3945 32.6355 27.9843 33.0457C27.5741 33.456 27.0177 33.6864 26.4375 33.6864C25.8573 33.6864 25.3009 33.456 24.8907 33.0457C24.4805 32.6355 24.25 32.0791 24.25 31.4989V27.1239C24.25 26.5438 24.4805 25.9874 24.8907 25.5771C25.3009 25.1669 25.8573 24.9364 26.4375 24.9364C27.0177 24.9364 27.5741 25.1669 27.9843 25.5771C28.3945 25.9874 28.625 26.5438 28.625 27.1239ZM19.875 27.1239V31.4989C19.875 32.0791 19.6445 32.6355 19.2343 33.0457C18.8241 33.456 18.2677 33.6864 17.6875 33.6864C17.1073 33.6864 16.5509 33.456 16.1407 33.0457C15.7305 32.6355 15.5 32.0791 15.5 31.4989V27.1239C15.5 26.5438 15.7305 25.9874 16.1407 25.5771C16.5509 25.1669 17.1073 24.9364 17.6875 24.9364C18.2677 24.9364 18.8241 25.1669 19.2343 25.5771C19.6445 25.9874 19.875 26.5438 19.875 27.1239ZM19.875 42.4364V46.8114C19.875 47.3916 19.6445 47.948 19.2343 48.3582C18.8241 48.7685 18.2677 48.9989 17.6875 48.9989C17.1073 48.9989 16.5509 48.7685 16.1407 48.3582C15.7305 47.948 15.5 47.3916 15.5 46.8114V42.4364C15.5 41.8563 15.7305 41.2999 16.1407 40.8896C16.5509 40.4794 17.1073 40.2489 17.6875 40.2489C18.2677 40.2489 18.8241 40.4794 19.2343 40.8896C19.6445 41.2999 19.875 41.8563 19.875 42.4364ZM28.625 42.4364V46.8114C28.625 47.3916 28.3945 47.948 27.9843 48.3582C27.5741 48.7685 27.0177 48.9989 26.4375 48.9989C25.8573 48.9989 25.3009 48.7685 24.8907 48.3582C24.4805 47.948 24.25 47.3916 24.25 46.8114V42.4364C24.25 41.8563 24.4805 41.2999 24.8907 40.8896C25.3009 40.4794 25.8573 40.2489 26.4375 40.2489C27.0177 40.2489 27.5741 40.4794 27.9843 40.8896C28.3945 41.2999 28.625 41.8563 28.625 42.4364Z" fill="white"/>
              </svg>
            </div>
            <span class="menu-label">Mis propiedades</span>
          </div>

          <!-- Prospectos -->
          <div 
            class="menu-item"
            @click="navigateTo('prospectos')"
          >
            <div class="menu-icon bg-black text-white hover:bg-tuin_hover transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" width="66" height="56" viewBox="0 0 66 56" fill="none">
                <path d="M63 53.168C63 47.3613 57.4333 42.4246 49.6667 40.5913M43 53.168C43 45.8013 34.0467 39.8346 23 39.8346C11.9533 39.8346 3 45.8013 3 53.168M43 29.8346C46.5362 29.8346 49.9276 28.4299 52.4281 25.9294C54.9286 23.4289 56.3333 20.0375 56.3333 16.5013C56.3333 12.9651 54.9286 9.5737 52.4281 7.07321C49.9276 4.57273 46.5362 3.16797 43 3.16797M23 29.8346C19.4638 29.8346 16.0724 28.4299 13.5719 25.9294C11.0714 23.4289 9.66667 20.0375 9.66667 16.5013C9.66667 12.9651 11.0714 9.5737 13.5719 7.07321C16.0724 4.57273 19.4638 3.16797 23 3.16797C26.5362 3.16797 29.9276 4.57273 32.4281 7.07321C34.9286 9.5737 36.3333 12.9651 36.3333 16.5013C36.3333 20.0375 34.9286 23.4289 32.4281 25.9294C29.9276 28.4299 26.5362 29.8346 23 29.8346Z" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="menu-label">Prospectos</span>
          </div>

          <!-- Mi inmobiliaria -->
          <div 
            class="menu-item"
            @click="navigateTo('mi-inmobiliaria')"
          >
            <div class="menu-icon bg-black text-white hover:bg-tuin_hover transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" width="60" height="56" viewBox="0 0 60 56" fill="none">
                <path d="M53.332 11.9987C55.0237 11.9987 56.3945 12.582 57.4737 13.7195C58.582 14.9154 59.1654 16.2279 59.1654 17.832V49.9154C59.1654 51.5195 58.582 52.832 57.4737 54.0279C56.3945 55.1654 55.0237 55.7487 53.332 55.7487H6.66536C4.9737 55.7487 3.60286 55.1654 2.5237 54.0279C1.41536 52.832 0.832031 51.5195 0.832031 49.9154V17.832C0.832031 16.2279 1.41536 14.9154 2.5237 13.7195C3.60286 12.582 4.9737 11.9987 6.66536 11.9987H18.332V6.16536C18.332 4.4737 18.9154 3.10286 20.0237 2.0237C21.1029 0.915364 22.4737 0.332031 24.1654 0.332031H35.832C37.5237 0.332031 38.8945 0.915364 39.9737 2.0237C41.082 3.10286 41.6654 4.4737 41.6654 6.16536V11.9987H53.332ZM6.66536 17.832V49.9154H53.332V17.832H6.66536ZM35.832 11.9987V6.16536H24.1654V11.9987H35.832Z" fill="white"/>
              </svg>
            </div>
            <span class="menu-label">Mi inmobiliaria</span>
          </div>

          <!-- Mi perfil -->
          <div 
            class="menu-item col-span-2"
            @click="navigateTo('mi-perfil')"
          >
            <div class="menu-icon bg-black text-white hover:bg-tuin_hover transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M46.6693 26.2526C46.6693 29.3468 45.4401 32.3143 43.2522 34.5022C41.0643 36.6901 38.0968 37.9193 35.0026 37.9193C31.9084 37.9193 28.9409 36.6901 26.753 34.5022C24.5651 32.3143 23.3359 29.3468 23.3359 26.2526C23.3359 23.1584 24.5651 20.1909 26.753 18.003C28.9409 15.8151 31.9084 14.5859 35.0026 14.5859C38.0968 14.5859 41.0643 15.8151 43.2522 18.003C45.4401 20.1909 46.6693 23.1584 46.6693 26.2526ZM40.8359 26.2526C40.8359 27.7997 40.2214 29.2834 39.1274 30.3774C38.0334 31.4714 36.5497 32.0859 35.0026 32.0859C33.4555 32.0859 31.9718 31.4714 30.8778 30.3774C29.7839 29.2834 29.1693 27.7997 29.1693 26.2526C29.1693 24.7055 29.7839 23.2218 30.8778 22.1278C31.9718 21.0339 33.4555 20.4193 35.0026 20.4193C36.5497 20.4193 38.0334 21.0339 39.1274 22.1278C40.2214 23.2218 40.8359 24.7055 40.8359 26.2526Z" fill="white"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M35.0013 2.91797C17.2826 2.91797 2.91797 17.2826 2.91797 35.0013C2.91797 52.72 17.2826 67.0846 35.0013 67.0846C52.72 67.0846 67.0846 52.72 67.0846 35.0013C67.0846 17.2826 52.72 2.91797 35.0013 2.91797ZM8.7513 35.0013C8.7513 41.0971 10.8309 46.7088 14.3163 51.1655C16.7647 47.9517 19.9226 45.3471 23.5436 43.5551C27.1646 41.7631 31.1507 40.832 35.1909 40.8346C39.1791 40.83 43.1157 41.7362 46.7004 43.4841C50.2852 45.232 53.4235 47.7754 55.8759 50.9205C58.403 47.606 60.1046 43.7373 60.8397 39.6347C61.5749 35.532 61.3226 31.3133 60.1036 27.3275C58.8846 23.3417 56.734 19.7035 53.8298 16.7139C50.9256 13.7243 47.3512 11.4692 43.4024 10.1353C39.4536 8.80135 35.244 8.42689 31.1217 9.04289C26.9995 9.65889 23.0832 11.2477 19.6969 13.6777C16.3106 16.1078 13.5516 19.3093 11.6482 23.0173C9.74486 26.7253 8.75183 30.8333 8.7513 35.0013ZM35.0013 61.2513C28.9752 61.2611 23.1309 59.1879 18.458 55.383C20.3387 52.6898 22.8423 50.4909 25.7557 48.9735C28.6691 47.4561 31.906 46.6651 35.1909 46.668C38.4347 46.6651 41.6324 47.4364 44.5183 48.9176C47.4042 50.3989 49.895 52.5474 51.7838 55.1846C47.0748 59.1134 41.134 61.2609 35.0013 61.2513Z" fill="white"/>
              </svg>
            </div>
            <span class="menu-label">Mi perfil</span>
          </div>
        </div>
      </div>
      <!-- Menu Grid Desktop -->
      <div class="hidden sm:block">
        <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 sm:gap-6 max-w-xl mx-auto">
        <!-- Bolsa Inmobiliaria -->
          <div 
            class="menu-item"
            @click="navigateTo('bolsa-inmobiliaria')"
          >
            <div class="menu-icon bg-black text-white hover:bg-tuin_hover transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" width="95" height="66" viewBox="0 0 95 66" fill="none">
                <path d="M94.37 22.5458L84.8997 3.59775C84.5508 2.90034 84.068 2.27849 83.4787 1.7677C82.8895 1.25691 82.2054 0.867193 81.4656 0.620803C80.7257 0.374414 79.9446 0.276179 79.1667 0.331708C78.3889 0.387236 77.6296 0.595442 76.9323 0.944433L67.7032 5.55713L48.2616 0.413769C47.7627 0.283952 47.239 0.283952 46.7401 0.413769L27.2985 5.55713L18.0694 0.944433C17.372 0.595442 16.6128 0.387236 15.835 0.331708C15.0571 0.276179 14.276 0.374414 13.5361 0.620803C12.7963 0.867193 12.1122 1.25691 11.523 1.7677C10.9337 2.27849 10.4509 2.90034 10.102 3.59775L0.631704 22.5421C0.282713 23.2394 0.0745079 23.9987 0.0189792 24.7765C-0.0365495 25.5544 0.0616858 26.3355 0.308075 27.0754C0.554464 27.8152 0.944181 28.4993 1.45497 29.0885C1.96576 29.6778 2.58761 30.1606 3.28502 30.5095L13.3046 35.5229L33.8965 50.2294C34.2001 50.445 34.5412 50.6023 34.9022 50.6933L58.6522 56.6308C59.1496 56.7555 59.6708 56.7493 60.165 56.6127C60.6593 56.4761 61.1097 56.2139 61.4725 55.8515L81.9087 35.4116L91.713 30.5095C93.1205 29.8049 94.1906 28.5702 94.6882 27.0769C95.1857 25.5836 95.0699 23.9538 94.3663 22.5458H94.37ZM74.0006 34.9292L61.2313 24.7019C60.6593 24.2437 59.938 24.0134 59.2063 24.0552C58.4746 24.097 57.7842 24.4079 57.268 24.9282C50.6589 31.5856 43.2926 30.7433 38.5946 27.7745L54.6407 12.1886H66.4452L76.5426 32.3798L74.0006 34.9292ZM15.4124 6.25107L23.0087 10.0437L13.5198 28.988L5.93834 25.1991L15.4124 6.25107ZM58.4592 50.4595L36.895 45.0712L18.6372 32.031L29.0278 11.2497L47.5008 6.35498L51.1376 7.31611L34.4383 23.5255L34.4087 23.5589C33.78 24.1875 33.3006 24.9492 33.0057 25.7879C32.7109 26.6266 32.6081 27.5207 32.705 28.4044C32.8018 29.2881 33.0959 30.1388 33.5655 30.8936C34.0351 31.6485 34.6682 32.2882 35.418 32.7657C43.0477 37.6382 52.2546 36.8478 59.5057 30.9103L69.7665 39.1522L58.4592 50.4595ZM81.4671 28.9843L71.9967 10.0585L79.5893 6.25107L89.0633 25.1991L81.4671 28.9843ZM48.9036 63.3735C48.7432 64.0152 48.3731 64.5849 47.8521 64.9923C47.3311 65.3997 46.689 65.6214 46.0276 65.6224C45.7836 65.6225 45.5406 65.5926 45.304 65.5333L29.8405 61.6665C29.4788 61.5772 29.1375 61.4198 28.8348 61.2026L19.0565 54.2187C18.4553 53.7466 18.0593 53.0608 17.951 52.3041C17.8428 51.5474 18.0306 50.778 18.4753 50.1563C18.9201 49.5346 19.5875 49.1084 20.3387 48.9665C21.0898 48.8246 21.8667 48.9779 22.5077 49.3944L31.8258 56.0519L46.7587 59.7776C47.5223 59.9687 48.1789 60.4552 48.5839 61.1302C48.9889 61.8053 49.1092 62.6135 48.9184 63.3772L48.9036 63.3735Z" fill="white"/>
              </svg>
            </div>
            <span class="menu-label">Bolsa Inmobiliaria</span>
          </div>

          <!-- Mis propiedades -->
          <div 
            class="menu-item"
            @click="navigateTo('mis-propiedades')"
          >
            <div class="menu-icon bg-black text-white hover:bg-tuin_hover transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" width="66" height="58" viewBox="0 0 66 58" fill="none">
                <path d="M63.625 53.3739H59.25V22.7489C59.25 21.5886 58.7891 20.4758 57.9686 19.6553C57.1481 18.8349 56.0353 18.3739 54.875 18.3739H37.375V5.24894C37.3755 4.45669 37.1609 3.67917 36.754 2.99937C36.3472 2.31957 35.7634 1.763 35.0649 1.38907C34.3665 1.01514 33.5796 0.837882 32.7883 0.87622C31.997 0.914559 31.2309 1.16705 30.5719 1.60675L8.69687 16.1864C8.09679 16.5868 7.60501 17.1294 7.26534 17.7658C6.92566 18.4022 6.74863 19.1127 6.75 19.8341V53.3739H2.375C1.79484 53.3739 1.23844 53.6044 0.828204 54.0146C0.417968 54.4249 0.1875 54.9813 0.1875 55.5614C0.1875 56.1416 0.417968 56.698 0.828204 57.1082C1.23844 57.5185 1.79484 57.7489 2.375 57.7489H63.625C64.2052 57.7489 64.7616 57.5185 65.1718 57.1082C65.582 56.698 65.8125 56.1416 65.8125 55.5614C65.8125 54.9813 65.582 54.4249 65.1718 54.0146C64.7616 53.6044 64.2052 53.3739 63.625 53.3739ZM54.875 22.7489V53.3739H37.375V22.7489H54.875ZM11.125 19.8341L33 5.24894V53.3739H11.125V19.8341ZM28.625 27.1239V31.4989C28.625 32.0791 28.3945 32.6355 27.9843 33.0457C27.5741 33.456 27.0177 33.6864 26.4375 33.6864C25.8573 33.6864 25.3009 33.456 24.8907 33.0457C24.4805 32.6355 24.25 32.0791 24.25 31.4989V27.1239C24.25 26.5438 24.4805 25.9874 24.8907 25.5771C25.3009 25.1669 25.8573 24.9364 26.4375 24.9364C27.0177 24.9364 27.5741 25.1669 27.9843 25.5771C28.3945 25.9874 28.625 26.5438 28.625 27.1239ZM19.875 27.1239V31.4989C19.875 32.0791 19.6445 32.6355 19.2343 33.0457C18.8241 33.456 18.2677 33.6864 17.6875 33.6864C17.1073 33.6864 16.5509 33.456 16.1407 33.0457C15.7305 32.6355 15.5 32.0791 15.5 31.4989V27.1239C15.5 26.5438 15.7305 25.9874 16.1407 25.5771C16.5509 25.1669 17.1073 24.9364 17.6875 24.9364C18.2677 24.9364 18.8241 25.1669 19.2343 25.5771C19.6445 25.9874 19.875 26.5438 19.875 27.1239ZM19.875 42.4364V46.8114C19.875 47.3916 19.6445 47.948 19.2343 48.3582C18.8241 48.7685 18.2677 48.9989 17.6875 48.9989C17.1073 48.9989 16.5509 48.7685 16.1407 48.3582C15.7305 47.948 15.5 47.3916 15.5 46.8114V42.4364C15.5 41.8563 15.7305 41.2999 16.1407 40.8896C16.5509 40.4794 17.1073 40.2489 17.6875 40.2489C18.2677 40.2489 18.8241 40.4794 19.2343 40.8896C19.6445 41.2999 19.875 41.8563 19.875 42.4364ZM28.625 42.4364V46.8114C28.625 47.3916 28.3945 47.948 27.9843 48.3582C27.5741 48.7685 27.0177 48.9989 26.4375 48.9989C25.8573 48.9989 25.3009 48.7685 24.8907 48.3582C24.4805 47.948 24.25 47.3916 24.25 46.8114V42.4364C24.25 41.8563 24.4805 41.2999 24.8907 40.8896C25.3009 40.4794 25.8573 40.2489 26.4375 40.2489C27.0177 40.2489 27.5741 40.4794 27.9843 40.8896C28.3945 41.2999 28.625 41.8563 28.625 42.4364Z" fill="white"/>
              </svg>
            </div>
            <span class="menu-label">Mis propiedades</span>
          </div>

          <!-- Prospectos -->
          <div 
            class="menu-item"
            @click="navigateTo('prospectos')"
          >
            <div class="menu-icon bg-black text-white hover:bg-tuin_hover transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" width="66" height="56" viewBox="0 0 66 56" fill="none">
                <path d="M63 53.168C63 47.3613 57.4333 42.4246 49.6667 40.5913M43 53.168C43 45.8013 34.0467 39.8346 23 39.8346C11.9533 39.8346 3 45.8013 3 53.168M43 29.8346C46.5362 29.8346 49.9276 28.4299 52.4281 25.9294C54.9286 23.4289 56.3333 20.0375 56.3333 16.5013C56.3333 12.9651 54.9286 9.5737 52.4281 7.07321C49.9276 4.57273 46.5362 3.16797 43 3.16797M23 29.8346C19.4638 29.8346 16.0724 28.4299 13.5719 25.9294C11.0714 23.4289 9.66667 20.0375 9.66667 16.5013C9.66667 12.9651 11.0714 9.5737 13.5719 7.07321C16.0724 4.57273 19.4638 3.16797 23 3.16797C26.5362 3.16797 29.9276 4.57273 32.4281 7.07321C34.9286 9.5737 36.3333 12.9651 36.3333 16.5013C36.3333 20.0375 34.9286 23.4289 32.4281 25.9294C29.9276 28.4299 26.5362 29.8346 23 29.8346Z" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="menu-label">Prospectos</span>
          </div>

            <div class="col-span-2 sm:col-span-3 lg:col-span-3 flex justify-center gap-11 mt-6">
              <!-- Mi inmobiliaria -->
              <div class="menu-item" @click="navigateTo('mi-inmobiliaria')">
                <div class="menu-icon bg-black text-white hover:bg-tuin_hover transition-colors">
                  <svg xmlns="http://www.w3.org/2000/svg" width="60" height="56" viewBox="0 0 60 56" fill="none">
                    <path d="M53.332 11.9987C55.0237 11.9987 56.3945 12.582 57.4737 13.7195C58.582 14.9154 59.1654 16.2279 59.1654 17.832V49.9154C59.1654 51.5195 58.582 52.832 57.4737 54.0279C56.3945 55.1654 55.0237 55.7487 53.332 55.7487H6.66536C4.9737 55.7487 3.60286 55.1654 2.5237 54.0279C1.41536 52.832 0.832031 51.5195 0.832031 49.9154V17.832C0.832031 16.2279 1.41536 14.9154 2.5237 13.7195C3.60286 12.582 4.9737 11.9987 6.66536 11.9987H18.332V6.16536C18.332 4.4737 18.9154 3.10286 20.0237 2.0237C21.1029 0.915364 22.4737 0.332031 24.1654 0.332031H35.832C37.5237 0.332031 38.8945 0.915364 39.9737 2.0237C41.082 3.10286 41.6654 4.4737 41.6654 6.16536V11.9987H53.332ZM6.66536 17.832V49.9154H53.332V17.832H6.66536ZM35.832 11.9987V6.16536H24.1654V11.9987H35.832Z" fill="white"/>
                  </svg>
                </div>
                <span class="menu-label">Mi inmobiliaria</span>
              </div>

              <!-- Mi perfil -->
              <div class="menu-item" @click="navigateTo('mi-perfil')">
                <div class="menu-icon bg-black text-white hover:bg-tuin_hover transition-colors">
                  <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M46.6693 26.2526C46.6693 29.3468 45.4401 32.3143 43.2522 34.5022C41.0643 36.6901 38.0968 37.9193 35.0026 37.9193C31.9084 37.9193 28.9409 36.6901 26.753 34.5022C24.5651 32.3143 23.3359 29.3468 23.3359 26.2526C23.3359 23.1584 24.5651 20.1909 26.753 18.003C28.9409 15.8151 31.9084 14.5859 35.0026 14.5859C38.0968 14.5859 41.0643 15.8151 43.2522 18.003C45.4401 20.1909 46.6693 23.1584 46.6693 26.2526ZM40.8359 26.2526C40.8359 27.7997 40.2214 29.2834 39.1274 30.3774C38.0334 31.4714 36.5497 32.0859 35.0026 32.0859C33.4555 32.0859 31.9718 31.4714 30.8778 30.3774C29.7839 29.2834 29.1693 27.7997 29.1693 26.2526C29.1693 24.7055 29.7839 23.2218 30.8778 22.1278C31.9718 21.0339 33.4555 20.4193 35.0026 20.4193C36.5497 20.4193 38.0334 21.0339 39.1274 22.1278C40.2214 23.2218 40.8359 24.7055 40.8359 26.2526Z" fill="white"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M35.0013 2.91797C17.2826 2.91797 2.91797 17.2826 2.91797 35.0013C2.91797 52.72 17.2826 67.0846 35.0013 67.0846C52.72 67.0846 67.0846 52.72 67.0846 35.0013C67.0846 17.2826 52.72 2.91797 35.0013 2.91797ZM8.7513 35.0013C8.7513 41.0971 10.8309 46.7088 14.3163 51.1655C16.7647 47.9517 19.9226 45.3471 23.5436 43.5551C27.1646 41.7631 31.1507 40.832 35.1909 40.8346C39.1791 40.83 43.1157 41.7362 46.7004 43.4841C50.2852 45.232 53.4235 47.7754 55.8759 50.9205C58.403 47.606 60.1046 43.7373 60.8397 39.6347C61.5749 35.532 61.3226 31.3133 60.1036 27.3275C58.8846 23.3417 56.734 19.7035 53.8298 16.7139C50.9256 13.7243 47.3512 11.4692 43.4024 10.1353C39.4536 8.80135 35.244 8.42689 31.1217 9.04289C26.9995 9.65889 23.0832 11.2477 19.6969 13.6777C16.3106 16.1078 13.5516 19.3093 11.6482 23.0173C9.74486 26.7253 8.75183 30.8333 8.7513 35.0013ZM35.0013 61.2513C28.9752 61.2611 23.1309 59.1879 18.458 55.383C20.3387 52.6898 22.8423 50.4909 25.7557 48.9735C28.6691 47.4561 31.906 46.6651 35.1909 46.668C38.4347 46.6651 41.6324 47.4364 44.5183 48.9176C47.4042 50.3989 49.895 52.5474 51.7838 55.1846C47.0748 59.1134 41.134 61.2609 35.0013 61.2513Z" fill="white"/>
                  </svg>
                </div>
                <span class="menu-label">Mi perfil</span>
              </div>
            </div>
        </div>
      </div>
    </div>

    <!-- Modales -->
    <ShareModalUser 
      v-if="showProfileModal && session && profileUrl"
      :slug_url="profileUrl"
      :session="session"
      @close="closeProfileModal"
      @copy-link="showToast('success', 'Enlace copiado al portapapeles')"
    />

    <ShareModalInmo 
      v-if="showCompanyModal && session && companyUrl"
      :slug_url="companyUrl"
      :session="session"
      @close="closeCompanyModal"
      @copy-link="showToast('success', 'Enlace copiado al portapapeles')"
    />
  </div>
</template>
  
<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import ToastAlert from '@/commond/ToastAlert.vue'
import ShareModalUser from '@/components/Home/Modal/shareModalUser.vue'
import ShareModalInmo from '@/components/Home/Modal/shareModalInmo.vue'
import axios from 'axios'
import { FwbTooltip } from 'flowbite-vue'
const router = useRouter()
const store = useStore()
let loader = ref(false);
let subscriptionStatus = ref('');
// Estado reactivo
const showShareMenu = ref(false)
const profileSlug = ref('')
const companySlug = ref('')
const toastAlert = ref(false)
const typeMsg = ref("")
const msg = ref("")

// Estados para los modales
const showProfileModal = ref(false)
const showCompanyModal = ref(false)

// Computed properties
const userName = computed(() => {
  const fullName = store.getters.getUserSession?.name || 'Usuario'
  // Extraer solo el primer nombre (primera palabra)
  return fullName.split(' ')[0]
})

const PLAN_LIMITS = {
  1: { limit: 3, name: 'Plan Básico' },
  2: { limit: 5, name: 'Plan Plus' },
  3: { limit: 10, name: 'Plan Premium' },
  4: { limit: Infinity, name: 'Plan Enterprise' },
  5: { limit: 3, name: 'Plan Básico' },
  6: { limit: 5, name: 'Plan Plus' },
  7: { limit: 10, name: 'Plan Premium' },
  8: { limit: Infinity, name: 'Plan Enterprise' },
  9: { limit: 0, name: 'Plan Gratuito' }
};
const myPropertiesCount = ref();
const propertyLimit = ref(Infinity);
const topElement = ref(null);
const currentPlanId = ref(null);
const planName = ref('')

const isLimitReached = computed(() => {
  console.log("esta es la cuenta: ",myPropertiesCount.value)
  return myPropertiesCount.value >= propertyLimit.value;
});

const session = computed(() => store.getters.getUserSession)
const apiBaseUrl = computed(() => process.env.VUE_APP_API_BASE_URL.replace(/\/api$/, ""))

// Computed properties para las URLs completas de los modales
const profileUrl = computed(() => {
  return profileSlug.value ? `${apiBaseUrl.value}/asesores-inmobiliarios/${profileSlug.value}` : ''
})

const companyUrl = computed(() => {
  return companySlug.value ? `${apiBaseUrl.value}/inmobiliarias/${companySlug.value}` : ''
})

// Métodos para obtener slugs
const getProfileSlug = async () => {
  try {
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${session.value.id}`,
      {
        headers: {
          Authorization: `Bearer ${session.value.token_api}`,
        },
      }
    )
    if (response.status === 200) {
      profileSlug.value = response.data.resp.info.slug
    }
  } catch (error) {
    console.error("Error obteniendo slug del perfil:", error)
  }
}

const getCompanySlug = async () => {
  try {
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${session.value.id}/company`,
      {
        headers: {
          Authorization: `Bearer ${session.value.token_api}`,
        },
      }
    )
    if (response.status === 200) {
      companySlug.value = response.data.resp.info.slug
    }
  } catch (error) {
    console.error("Error obteniendo slug de la inmobiliaria:", error)
  }
}

/* Función para copiar al portapapeles
const copyToClipboard = async (text, type) => {
  try {
    await navigator.clipboard.writeText(text)
    showToast('success', `URL ${type} copiada al portapapeles`)
  } catch (error) {
    console.error('Error al copiar al portapapeles:', error)
    showToast('danger', 'Error al copiar la URL')
  }
}*/

// Funciones para ToastAlert
async function showToast(type, message){
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast()
  }, 3000);
}

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}

// Funciones para controlar los modales
const openProfileModal = () => {
  if (session.value && profileUrl.value) {
    showProfileModal.value = true
    showShareMenu.value = false
  } else {
    showToast('danger', 'Error al cargar información del perfil')
  }
}

const closeProfileModal = () => {
  showProfileModal.value = false
}

const openCompanyModal = () => {
  if (session.value && companyUrl.value) {
    showCompanyModal.value = true
    showShareMenu.value = false
  } else {
    showToast('danger', 'Error al cargar información de la inmobiliaria')
  }
}

const closeCompanyModal = () => {
  showCompanyModal.value = false
}

// Métodos existentes
const toggleShareMenu = () => {
  showShareMenu.value = !showShareMenu.value
}

const handleAddProperty = () => {
  if (isLimitReached.value) {
    showToast('warning', `Has alcanzado el límite de ${propertyLimit.value} propiedades para tu plan actual`)
    setTimeout(() => {
      router.push('/info-payments')
    }, 2000)
  } else {
    router.push({ name: 'propertyForm' })
  }
}

const addProperty = () => {
  handleAddProperty()
}

const navigateTo = (section) => {
  switch (section) {
    case 'bolsa-inmobiliaria':
      router.push({ name: 'exchange_list' })
      break
    case 'mis-propiedades':
      router.push({ name: 'propertyList' })
      break
    case 'prospectos':
      router.push({ name: 'leads' })
      break
    case 'mi-inmobiliaria':
      router.push({ name: 'info_company' })
      break
    case 'mi-perfil':
      router.push({ name: 'info_profile' })
      break
    default:
      console.log(`Navegando a: ${section}`)
  }
}

// Cerrar el menú de compartir cuando se hace clic fuera
const closeShareMenu = () => {
  showShareMenu.value = false
}

async function checkSubscription() {
  try {
    const options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/checkActive/${session.value.id}`,
      options
    );

    const data = response.data?.original;

    if (data) {
      const status = data.status;
      const planId = data.plan_id;
      
      // Guardar información del plan
      currentPlanId.value = planId;
      
      // Establecer límite de propiedades
      if (PLAN_LIMITS[planId]) {
        propertyLimit.value = PLAN_LIMITS[planId].limit;
        planName.value = PLAN_LIMITS[planId].name;
      }

      // Validaciones de suscripción
      if (status !== 'active') {
        subscriptionStatus.value = 'expired';
        console.warn('Suscripción inactiva:', data.message);
        return;
      }

      // Segunda validación: si el plan es el gratuito (id = 9)
      if (planId === 9) {
        subscriptionStatus.value = 'expired';
        console.warn('Suscripción gratuita (no válida).');
        return;
      }

      // Si pasa ambas validaciones
      subscriptionStatus.value = 'active';

    } else {
      // Sin datos válidos en la respuesta
      subscriptionStatus.value = 'expired';
    }

  } catch (error) {
    console.error('Error al verificar suscripción:', error);
    subscriptionStatus.value = 'expired';
  }
}
async function get_count_propierties() {
  loader.value = true;
  try {
    let url_cnn = '';
    
    url_cnn = `${process.env.VUE_APP_API_BASE_URL}/broker/properties_count/${session.value.id}`;

    var options = {
      headers: {
        "Content-Type": "application/json", // Es importante establecer el tipo de contenido para el envío de archivos
        Authorization: `Bearer ${session.value.token_api}`, // Reemplaza tuTokenBearer con tu token real
      },
    };

    const response = await axios.get(url_cnn, options);
    if (response.status == 200) {
      console.log(response.data)
      myPropertiesCount.value = response.data.total_active_properties;
      //console.log('Propiedades encontradas',properties.value);
      scrollToTop()
    }
       
    loader.value = false;
  } catch (error) {
    console.error('ERROR', error)
    loader.value = false;
    if (error.response && error.response.status === 401) {
      store.dispatch("clearUserSession");
      router.push({ name: "login" });
    }
  }
}

async function callActionLog(user_id, type_action, detail){

let link = `${process.env.VUE_APP_API_BASE_URL}/event/add_log`;
let param_analytics = {
      "user_id":              user_id,
      "activity_id":          type_action,
      "description":          detail,
      "company_id":           session.value.company_id,          
}
//console.log(param_analytics)

let options = {
  headers: {
    "Content-Type": "application/json"
  },
};

try {
  const response = await axios.post(link, param_analytics, options);

  if (response.status == 401) {
    //console.log("Hay que sacarlo de la sesion ");
  }

  if (response.status == 200) {
    console.log(response);
  }
  
} catch (error) {
  console.error("Error fetching data:", error);
}

}
const scrollToTop = () => {
  if (topElement.value) {
    topElement.value.scrollIntoView({ behavior: 'smooth' });
  }
};
// Lifecycle
onMounted(async () => {
  loader.value = true;
  // Obtener los slugs al cargar el componente
  store.dispatch("updateStep", 3);
  await getProfileSlug()
  await getCompanySlug()
  await checkSubscription()
  await get_count_propierties()
  loader.value = false;
  
  // Agregar event listener para cerrar el menú al hacer clic fuera
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.relative')) {
      closeShareMenu()
    }
  })
})
</script>
  
<style scoped>
.menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s ease;
}


.menu-icon {
  width: 4rem;
  height: 4rem;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.75rem;
}

.menu-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #1f2937;
}


/* Responsive adjustments */
@media (min-width: 640px) {
  .menu-icon {
    width: 154px;
    height: 127px;
  }
  
  .menu-label {
    font-size: 1rem;
  }
}

@media (max-width: 640px) {
  .menu-icon {
    width: 126px;
    height: 104px;
  }
  
  .menu-label {
    font-size: 0.75rem;
  }
}

/* Dropdown animation */
.dropdown-enter-active, .dropdown-leave-active {
  transition: all 0.3s ease;
}

.dropdown-enter-from, .dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
  